import { urls } from '@sendible/common';

const { baseUrl, twBaseUrl } = urls;

export const CampaignsUrls = {
  campaign: `${baseUrl}/1.0/api/campaign`,
  campaigns: `${baseUrl}/1.0/api/campaigns`,
  overview: `${baseUrl}/1.0/api/campaign/overview`,
};

export const ReportsUrls = {
  quickReports: `${baseUrl}/api/v2/quick_reports.json`,
  campaignAudienceGrowth: `${baseUrl}/1.0/api/campaign/report/audience`,
  campaignOverview: `${baseUrl}/1.0/api/campaign/report/overview`,
  campaignPosts: `${baseUrl}/1.0/api/campaign/report/posts`,
  tiktok: `${baseUrl}/0.2/tw/tiktok/report`,
  tiktokProfiles: `${baseUrl}/api/v2/accounts.json`,
};

export const AiAssistUrls = {
  content: `${baseUrl}/1.0/api/ai/content`,
  content_generator: `${baseUrl}/1.0/api/ai/text_generation`,
};

export const ReportingUrls = {
  // Connectable social profiles
  profiles: `${twBaseUrl}/v1.0/filters`,

  // Module definitions (catalogue)
  moduleDefinitions: `${twBaseUrl}/v1.0/report-module-definitions`,
  moduleDefinition: (id: string) => `${twBaseUrl}/v1.0/report-module-definitions/${id}`,

  // Reports CRUD
  reports: `${twBaseUrl}/v1.0/reports`,
  report: (id: string) => `${twBaseUrl}/v1.0/reports/${id}`,
  reportDuplicate: (id: string) => `${twBaseUrl}/v1.0/reports/${id}/duplicate`,

  // Report profiles
  reportProfiles: (reportId: string) => `${twBaseUrl}/v1.0/reports/${reportId}/profiles`,
  reportProfile: (reportId: string, profileId: string) => `${twBaseUrl}/v1.0/reports/${reportId}/profiles/${profileId}`,

  // Report modules
  reportModules: (reportId: string) => `${twBaseUrl}/v1.0/reports/${reportId}/modules`,
  reportModule: (reportId: string, moduleId: string) => `${twBaseUrl}/v1.0/reports/${reportId}/modules/${moduleId}`,

  // Templates
  templates: `${twBaseUrl}/v1.0/report-templates`,
  template: (id: string) => `${twBaseUrl}/v1.0/report-templates/${id}`,

  // Module metrics data
  moduleData: `${twBaseUrl}/v1.0/report-module-data`,
};

export const ProfilesUrls = {
  account: `${baseUrl}/api/v3/account`,
  blueskyAuthenticate: `${baseUrl}/1.0/tw/bluesky/authenticate`,
  reminders: `${baseUrl}/1.0/tw/reminders`,
};
